module.exports = __webpack_public_path__ + "img/card-bg-01.132ebbc7.png";